import { TradingDetailsServicePlanBusinessFormNew_MX } from './mixed';

export const TradingDetailsServicePlanBusinessFormNew = {
  SPB: TradingDetailsServicePlanBusinessFormNew_MX,
};
